package org.vreo.devicehub.features.deviceDetails.presentation

/**
 * Device details UI actions
 */
sealed interface DeviceDetailsActions {
    data object OnClearError : DeviceDetailsActions
    data object Refresh : DeviceDetailsActions
    data class OnChangeEditTagEnable(val value: Boolean) : DeviceDetailsActions
    data class OnChangeEditTag(val value: String) : DeviceDetailsActions
    data object OnSaveTag : DeviceDetailsActions
    data object OnUnlinkClicked : DeviceDetailsActions
    data object OnClearUnlinkDialog : DeviceDetailsActions
    data object OnUnlinkDeviceConfirmed : DeviceDetailsActions
    data object OnDeleteClicked : DeviceDetailsActions
    data object OnClearDeleteDialog : DeviceDetailsActions
    data object OnDeleteConfirmed : DeviceDetailsActions
}